module.exports = __webpack_public_path__ + "static/media/undraw_No_data_re_kwbl.291ee7ec.svg";